import clsx from 'clsx';
import { Tabs } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';

interface RootProps extends ComponentProps<typeof Tabs.Root> {
  children?: ReactNode;
}
const HubertTabs = ({ children, ...props }: RootProps) => {
  return <Tabs.Root {...props}>{children}</Tabs.Root>;
};

interface TriggerProps extends ComponentProps<typeof Tabs.Trigger> {
  className?: string;
  children: ReactNode;
}
function Trigger({ className, children, ...props }: TriggerProps) {
  return (
    <Tabs.Trigger
      {...props}
      className={clsx(
        'bg-white px-10',
        'h-[30px] max-w-[120px]',
        'data-[state=inactive]:text-gray-400',
        'data-[state=inactive]:hover:text-gray-500',
        'data-[state=active]:bg-gray-50',
        'data-[state=active]:text-gray-500',
        'data-[state=active]:shadow-[inset_0_-1px_0_0,0_1px_0_0]',
        'data-[state=active]:shadow-current',
        'data-[state=inactive]:hover:shadow-[inset_0_-1px_0_0,0_1px_0_0]',
        'data-[state=inactive]:hover:shadow-gray-400',
        'cursor-pointer',
        'flex flex-1 items-center justify-center',
        'text-[14px] leading-none select-none',
        'outline-none hover:text-gray-800',
        'whitespace-nowrap',
        className,
      )}
    >
      {children}
    </Tabs.Trigger>
  );
}

interface ListProps extends ComponentProps<typeof Tabs.List> {
  className?: string;
  children: ReactNode;
}
function List({ className, children, ...props }: ListProps) {
  return (
    <Tabs.List
      {...props}
      className={clsx(
        'h-[var(--tabsVisibleHeight)] max-h-[var(--tabsVisibleHeight)]',
        'flex shrink-0 border-b',
        className,
      )}
    >
      {children}
    </Tabs.List>
  );
}

interface ContentProps extends ComponentProps<typeof Tabs.Content> {
  children: ReactNode;
}
function Content({ children, ...props }: ContentProps) {
  return <Tabs.Content {...props}>{children}</Tabs.Content>;
}

HubertTabs.List = List;
HubertTabs.Trigger = Trigger;
HubertTabs.Content = Content;
export default HubertTabs;
